import { api } from "@/lib/orgApi";

export const SCH_STATUSES = [
  { id: "recorded", label: "Recorded" },
  { id: "on-test", label: "On TEST" },
  { id: "in-production", label: "In production" },
];

export async function listSystemChanges() {
  const { data } = await api.get("/system-change-history");
  return data;
}

export async function createSystemChange(payload) {
  const { data } = await api.post("/system-change-history", payload);
  return data;
}

export async function updateSystemChangeStatus(id, status) {
  const { data } = await api.patch(`/system-change-history/${encodeURIComponent(id)}`, { status });
  return data;
}
